import React, { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Header, Section } from '../../webShop/WebShopHelper'
import { RoutePath } from '../../../types/Routes'

const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: inherit;

  &:link,
  &:hover,
  &:active {
    color: #0066cc;
    text-decoration: underline;
  }

  &:hover {
    text-decoration: none;
  }
`

export default function AnnouncementBarNote(): ReactElement {
  return (
    <Section>
      <Header>
        <h3>Announcement bar</h3>
      </Header>
      <p>
        To highlight your Promotion with an announcement bar on the webshop please{' '}
        <StyledLink to={RoutePath.WebShop}>click here</StyledLink>.
      </p>
    </Section>
  )
}
